export enum CLEANERS_ACTIONS {
  SEARCH_CLEANERS = 'SEARCH_CLEANERS',
  CREATE_CLEANER = 'CREATE_CLEANER',
  GET_CLEANER_DETAIL = 'GET_CLEANER_DETAIL',
  FETCH_FAVORITES = 'FETCH_FAVORITES',
  REMOVE_FAVORITE = 'REMOVE_FAVORITE',
  ADD_FAVORITE = 'ADD_FAVORITE',
  FIND_SLOTS = 'FIND_SLOTS',
  GET_CLEANER_PROFILE = 'GET_CLEANER_PROFILE',
  SET_EDITING_CLEANER = 'SET_EDITING_CLEANER',
  UPDATE_CLEANER_DATA = 'UPDATE_CLEANER_DATA',
  CHANGE_CLEANER_VISIBILITY = 'CHANGE_CLEANER_VISIBILITY',
}

export enum CLEANER_LOADERS {
  CREATE_CLEANER = 'CREATE_CLEANER',
  LOAD_MORE = 'LOAD_MORE',
  SEARCH_CLEANERS = 'SEARCH_CLEANERS',
  GET_CLEANER_DETAIL = 'GET_CLEANER_DETAIL',
  SEARCH_FAVORITES = 'SEARCH_FAVORITES',
  TOGGLE_FAVORITE = 'TOGGLE_FAVORITE',
  FIND_SLOTS = 'FIND_SLOTS',
  GET_CLEANER_PROFILE = 'GET_CLEANER_PROFILE',
  UPDATE_CLEANER_DATA = 'UPDATE_CLEANER_DATA',
  CHANGE_CLEANER_VISIBILITY = 'CHANGE_CLEANER_VISIBILITY',
}
